import * as PropTypes from 'prop-types';
import * as React from 'react';
import { filter } from 'lodash';
import PromoProduct from './promo_product';
import Savings from './savings';
import PriceWithChange from './price_with_change';
import ProductBundleCalculator from './product_bundle_calculator';

class ProductBundlePreview extends React.Component {
  static propTypes = {
    productBundle: PropTypes.object.isRequired,
  };

  bundledProductsWithListings = () =>
    filter(this.props.productBundle.bundled_products, bundledProduct => bundledProduct.listing);

  renderBundledListings = () =>
    this.bundledProductsWithListings().map(bundledProduct => (
      <PromoProduct
        key={bundledProduct.listing.id}
        listing={bundledProduct.listing}
        bundledPrice={bundledProduct.listing.buyer_price}
        originalPrice={bundledProduct.listing.original_price}
      />
    ));

  renderSavings = () => (
    <Savings
      price={ProductBundleCalculator.originalPrice(this.props.productBundle)}
      bundledPrice={ProductBundleCalculator.discountedPrice(this.props.productBundle)}
      symbol={this.props.productBundle.main_listing.price.symbol}
      bundledProductsCount={ProductBundleCalculator.bundledProductsCount(this.props.productBundle)}
    />
  );

  render() {
    return (
      <div className="product-bundle-preview">
        <PromoProduct
          listing={this.props.productBundle.main_listing}
          originalPrice={this.props.productBundle.main_listing.price}
        />
        {this.renderBundledListings()}
        <div className="align-center">
          <h4 className="heading-2 mt-1">
            <PriceWithChange price={ProductBundleCalculator.totalPrice(this.props.productBundle)} />
          </h4>
          {this.renderSavings()}
        </div>
        <a className="btn btn-primary btn-disabled wide mt-1">
          {I18n.t('js.productBundles.promo.addToCart', {
            count: ProductBundleCalculator.bundledProductsCount(this.props.productBundle),
            totalCount: ProductBundleCalculator.bundledProductsCount(this.props.productBundle) + 1,
          })}
        </a>
      </div>
    );
  }
}

export default ProductBundlePreview;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle_preview.jsx